import React from 'react';
import DropMenu from '@roo/roo/DropMenu';
import * as LX from '@utils/lxWrapper';
import * as Ids from '@utils/ids';
import Button from '@roo/roo/Button';
import * as PrinterUtils from '@utils/print/printer';

import { isInApp } from '@utils/getEnv';
import Horn from '@utils/horn'; // eslint-disable-line import/no-cycle
import { ICommoneHornGrayConfig, isHitGray } from '@utils/commonHornGrayUtils';

import pageJump from '@projects/Shell/utils/pageJump';
import styles from './PrintStatus.module.scss';

const { useState, useEffect, useMemo, useCallback } = React;

/** 打印机 链接逻辑 */
const PrintStatus: React.FC = () => {
    /** 打印机连接状态 */
    const [printStatus, setPrintStatus] = useState(false);
    const [hitGray, setHitGray] = useState(false);

    // 获取打印机连接状态
    useEffect(() => {
        if (!isInApp) return;
        const allPinterStatus =
            (PrinterUtils && PrinterUtils.getPoiEnabledConnectedPrinters(Ids.getWmPoiId())) || [];
        const status = !!allPinterStatus.length;
        setPrintStatus(status);
    }, []);

    /**
     * 打印机icon异常
     *
     * 【总店】或【浏览器访问】或【客户端访问但是没有连接打印机】
     */
    const printIconWarning = useMemo(() => {
        return Ids.getWmPoiId() === '-1' || !isInApp || !printStatus;
    }, [printStatus]);

    const download = useCallback(() => {
        if (hitGray) {
            LX.reportMC('b_waimai_e_away998t_mc', 'c_waimai_e_fa4ps4ng');
            pageJump.go('/new_fe/business#/pcClient/download');
        } else {
            LX.reportMC('b_waimai_e_geae8mys_mc', 'c_waimai_e_fa4ps4ng');
            window.open('/gw/version/pc/download');
        }
    }, [hitGray]);

    // 获取Horn灰度配置
    useEffect(() => {
        let result = false;
        try {
            const grayResponse = Horn.getConfigByFieldName<{
                shellEntry: ICommoneHornGrayConfig;
                loginEntry: ICommoneHornGrayConfig;
            }>(Horn.CONFIG_FIELD.PC_CLIENT_DOWNLOAD_GRAY);
            const grayInfo = grayResponse?.shellEntry;
            if (!grayInfo) {
                result = false;
            } else {
                result = isHitGray(grayInfo);
            }
            setHitGray(result);
        } catch (error) {
            setHitGray(result);
            // Woops~~, Something wrong
        }
    }, []);

    const menuRender = () => {
        return (
            <div className={styles.dropMenu}>
                {Ids.getWmPoiId() === '-1' ? (
                    <div className={styles.printWrong}>请切换到单店设置打印机</div>
                ) : (
                    <>
                        {printStatus ? (
                            <div className={styles.printStatus}>
                                <i className="iconfont icon-wmbwmb-checkmark" />
                                打印机连接正常
                            </div>
                        ) : (
                            <div className={styles.printWrong}>打印机连接断开</div>
                        )}
                    </>
                )}

                {isInApp ? (
                    <Button
                        size="small"
                        onClick={() => {
                            pageJump.go('/new_fe/business#/settings/printer');
                        }}
                    >
                        设置
                    </Button>
                ) : (
                    <div className={styles.downloadApp}>
                        <span>
                            请
                            <span className={styles.download} onClick={download}>
                                下载
                            </span>
                            美团外卖商家版-电脑端进行设置
                        </span>
                    </div>
                )}
            </div>
        );
    };

    return (
        <>
            <DropMenu
                placement="bottomRight"
                menuComponent={menuRender()}
                trigger="hover"
                flip={false}
            >
                <div className={styles.menuContainer}>
                    <i
                        className={`iconfont icon-wmbwmb-printer ${
                            printIconWarning ? styles.warningIcon : ''
                        }`}
                    />
                </div>
            </DropMenu>
        </>
    );
};

export default PrintStatus;
